var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 528,
    viewBox: "0 0 528 528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_11_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.143 163.366L232.474 8L172.56 81.8971L238.564 163.366L172.226 245.248L232.474 318.732L359.143 163.366Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.143 163.366L232.474 8L172.56 81.8971L238.564 163.366L172.226 245.248L232.474 318.732L359.143 163.366Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.474 8L233.249 7.3681L232.471 6.41481L231.697 7.37022L232.474 8ZM359.143 163.366L359.918 163.998L360.433 163.366L359.918 162.734L359.143 163.366ZM172.56 81.8971L171.783 81.2673L171.273 81.8969L171.783 82.5266L172.56 81.8971ZM238.564 163.366L239.341 163.995L239.851 163.366L239.341 162.736L238.564 163.366ZM172.226 245.248L171.449 244.618L170.936 245.251L171.452 245.882L172.226 245.248ZM232.474 318.732L231.7 319.366L232.476 320.312L233.249 319.364L232.474 318.732ZM231.699 8.6319L358.368 163.998L359.918 162.734L233.249 7.3681L231.699 8.6319ZM173.337 82.5269L233.25 8.62978L231.697 7.37022L171.783 81.2673L173.337 82.5269ZM239.341 162.736L173.337 81.2676L171.783 82.5266L237.787 163.995L239.341 162.736ZM173.003 245.877L239.341 163.995L237.787 162.736L171.449 244.618L173.003 245.877ZM233.247 318.098L172.999 244.614L171.452 245.882L231.7 319.366L233.247 318.098ZM358.368 162.734L231.699 318.1L233.249 319.364L359.918 163.998L358.368 162.734Z",
    fill: "#E7E7E7",
    mask: "url(#path-1-inside-1_11_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_11_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.917 163.366L68.248 8L8.33461 81.8971L74.338 163.366L7.99999 245.248L68.248 318.732L194.917 163.366Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.917 163.366L68.248 8L8.33461 81.8971L74.338 163.366L7.99999 245.248L68.248 318.732L194.917 163.366Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.248 8L69.023 7.3681L68.2458 6.41481L67.4712 7.37022L68.248 8ZM194.917 163.366L195.693 163.998L196.208 163.366L195.693 162.734L194.917 163.366ZM8.33461 81.8971L7.55784 81.2673L7.04742 81.8969L7.55761 82.5266L8.33461 81.8971ZM74.338 163.366L75.115 163.995L75.625 163.366L75.115 162.736L74.338 163.366ZM7.99999 245.248L7.22299 244.618L6.70994 245.251L7.22667 245.882L7.99999 245.248ZM68.248 318.732L67.4747 319.366L68.2501 320.312L69.023 319.364L68.248 318.732ZM67.4729 8.6319L194.142 163.998L195.693 162.734L69.023 7.3681L67.4729 8.6319ZM9.11138 82.5269L69.0248 8.62978L67.4712 7.37022L7.55784 81.2673L9.11138 82.5269ZM75.115 162.736L9.11161 81.2676L7.55761 82.5266L73.561 163.995L75.115 162.736ZM8.77699 245.877L75.115 163.995L73.561 162.736L7.22299 244.618L8.77699 245.877ZM69.0213 318.098L8.7733 244.614L7.22667 245.882L67.4747 319.366L69.0213 318.098ZM194.142 162.734L67.4729 318.1L69.023 319.364L195.693 163.998L194.142 162.734Z",
    fill: "#E7E7E7",
    mask: "url(#path-3-inside-2_11_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_11_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.333 371.52L150.44 269.482L90.526 343.38L156.529 424.848L229.333 520L229.333 520L229.333 425.28L229.333 371.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.333 371.52L150.44 269.482L90.526 343.38L156.529 424.848L229.333 520L229.333 520L229.333 425.28L229.333 371.52Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44 269.482L151.231 268.87L150.458 267.871L149.663 268.852L150.44 269.482ZM229.333 371.52L230.333 371.52L230.333 371.179L230.124 370.908L229.333 371.52ZM90.526 343.38L89.7492 342.75L89.2388 343.379L89.749 344.009L90.526 343.38ZM156.529 424.848L157.323 424.24L157.315 424.229L157.306 424.219L156.529 424.848ZM229.333 520L228.539 520.608L229.075 521.309L229.837 520.864L229.333 520ZM229.333 520L229.837 520.864L230.333 520.574L230.333 520L229.333 520ZM229.333 425.28L228.333 425.28V425.28L229.333 425.28ZM149.649 270.094L228.542 372.132L230.124 370.908L151.231 268.87L149.649 270.094ZM91.3028 344.009L151.217 270.112L149.663 268.852L89.7492 342.75L91.3028 344.009ZM157.306 424.219L91.303 342.75L89.749 344.009L155.752 425.478L157.306 424.219ZM230.127 519.392L157.323 424.24L155.735 425.456L228.539 520.608L230.127 519.392ZM228.829 519.136L228.829 519.136L229.837 520.864L229.837 520.864L228.829 519.136ZM228.333 425.28L228.333 520L230.333 520L230.333 425.28L228.333 425.28ZM228.333 371.52L228.333 425.28L230.333 425.28L230.333 371.52L228.333 371.52Z",
    fill: "#E7E7E7",
    mask: "url(#path-5-inside-3_11_2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_11_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520 163.366L393.33 8L333.417 81.8971L399.42 163.366L333.082 245.248L393.33 318.732L520 163.366Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520 163.366L393.33 8L333.417 81.8971L399.42 163.366L333.082 245.248L393.33 318.732L520 163.366Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33 8L394.106 7.3681L393.328 6.41481L392.554 7.37022L393.33 8ZM520 163.366L520.775 163.998L521.29 163.366L520.775 162.734L520 163.366ZM333.417 81.8971L332.64 81.2673L332.13 81.8969L332.64 82.5266L333.417 81.8971ZM399.42 163.366L400.197 163.995L400.707 163.366L400.197 162.736L399.42 163.366ZM333.082 245.248L332.305 244.618L331.792 245.251L332.309 245.882L333.082 245.248ZM393.33 318.732L392.557 319.366L393.333 320.312L394.106 319.364L393.33 318.732ZM392.555 8.6319L519.225 163.998L520.775 162.734L394.106 7.3681L392.555 8.6319ZM334.194 82.5269L394.107 8.62978L392.554 7.37022L332.64 81.2673L334.194 82.5269ZM400.197 162.736L334.194 81.2676L332.64 82.5266L398.643 163.995L400.197 162.736ZM333.859 245.877L400.197 163.995L398.643 162.736L332.305 244.618L333.859 245.877ZM394.104 318.098L333.856 244.614L332.309 245.882L392.557 319.366L394.104 318.098ZM519.225 162.734L392.555 318.1L394.106 319.364L520.775 163.998L519.225 162.734Z",
    fill: "#E7E7E7",
    mask: "url(#path-7-inside-4_11_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_2",
    x: 0,
    y: 0,
    width: 528,
    height: 528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0583333 0 0 0 0 0.0583333 0 0 0 0 0.0583333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff273520c2d8a4b88523b7560e68e716.svg";
export { ForwardRef as ReactComponent };